import { render, staticRenderFns } from "./RecurringTimeLimitEditor.vue?vue&type=template&id=56c53980&scoped=true&"
import script from "./RecurringTimeLimitEditor.vue?vue&type=script&lang=js&"
export * from "./RecurringTimeLimitEditor.vue?vue&type=script&lang=js&"
import style0 from "./RecurringTimeLimitEditor.vue?vue&type=style&index=0&id=56c53980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c53980",
  null
  
)

export default component.exports